export enum actionTypesDelivery {
  ListOfDelivery = "deliveryList",
  IsDeliveryTableRefreshed = "isDeliveryTableRefreshed",
  SelectedDelivery = "selectedDelivery",
  AddRecentUpload = "addRecentUpload",
}

export enum actionTypesStockTransfer {
  ListOfStockTransfer = "stockTransferList",
  IsStockTransferTableRefreshed = "isStockTransferTableRefreshed",
  SelectedStockTransfer = "selectedStockTransfer",
}
